import { render, staticRenderFns } from "./AuthPolicySettings.vue?vue&type=template&id=212bd716&scoped=true&"
import script from "./AuthPolicySettings.vue?vue&type=script&lang=js&"
export * from "./AuthPolicySettings.vue?vue&type=script&lang=js&"
import style0 from "./AuthPolicySettings.vue?vue&type=style&index=0&id=212bd716&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212bd716",
  null
  
)

export default component.exports